import { render, staticRenderFns } from "./assetChangeDetail.vue?vue&type=template&id=0229d9d0"
import script from "./assetChangeDetail.vue?vue&type=script&lang=js"
export * from "./assetChangeDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports